import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
export default function RedirectReloadable({ to, reload, ...rest }) {
    useEffect(() => {
        if (reload && window.location.pathname === to) {
            window.location.reload();
        }
    }, [to, reload]);
    return React.createElement(Redirect, { to: to, ...rest });
}
